export const AppMutationTypes = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
  TOGGLE_DEVICE: 'TOGGLE_DEVICE',
  SET_SIZE: 'SET_SIZE'
}
